import script from "./TheDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheDialog.vue?vue&type=script&setup=true&lang=ts"

import "./TheDialog.vue?vue&type=style&index=0&id=2cfde4d0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cfde4d0"]])